"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const tinymce_react_1 = require("@tinymce/tinymce-react");
require("tinymce/tinymce"); // core
require("tinymce/icons/default");
require("tinymce/themes/silver");
require("tinymce/models/dom");
// Import the plugins you need
require("tinymce/plugins/advlist");
require("tinymce/plugins/autolink");
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/charmap");
require("tinymce/plugins/preview");
require("tinymce/plugins/anchor");
require("tinymce/plugins/searchreplace");
require("tinymce/plugins/visualblocks");
require("tinymce/plugins/code");
require("tinymce/plugins/insertdatetime");
require("tinymce/plugins/table");
require("tinymce/plugins/wordcount");
const RichTextEditorToolbar = ({ value, onChange, disabled, contentStyle, }) => {
    const [editorValue, setEditorValue] = react_1.default.useState(value);
    // Keep local editor state in sync when parent value changes
    react_1.default.useEffect(() => {
        setEditorValue(value);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            height: "100%",
            width: "100%",
            background: "#fff",
            borderBottom: "1px solid #eee",
        }, children: (0, jsx_runtime_1.jsx)(tinymce_react_1.Editor, { licenseKey: "gpl", value: editorValue, onEditorChange: (content) => {
                setEditorValue(content);
                if (onChange)
                    onChange(content);
            }, disabled: !!disabled, init: {
                base_url: "/tinymce", // 👈 Important: where to load skins/themes from
                suffix: ".min", // optional, ensures it loads .min.js/.css
                height: "100%",
                menubar: false,
                branding: false,
                plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "charmap",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "insertdatetime",
                    "table",
                    "wordcount",
                ],
                toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link table code",
                content_style: "body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji'; font-size:14px }" +
                    (contentStyle || ""),
                valid_elements: "*[*]",
                extended_valid_elements: "style[type]",
                verify_html: false,
                valid_children: "+body[style]",
            } }) }));
};
exports.default = RichTextEditorToolbar;
